import Parent from "parentjs/controllers/replace_content_controller.js";
export default Parent;
